import { CanadianCriminalReportState } from "shared/types";
import { EmptyCellIcon } from "./TableBodySections/components/EmptyCellIcon";
import { Verification } from "views/applications-id/components/ApplicantsTable/types";
import { getCanadianCriminalReportState } from "views/applications-id/components/ApplicantsTable/utils";

const STATE_LABELS: Record<
  CanadianCriminalReportState,
  { label: string; className: string }
> = {
  [CanadianCriminalReportState.InProgress]: {
    label: "In-progress",
    className: "text-content-500"
  },
  [CanadianCriminalReportState.Issue]: {
    label: "Issues with report",
    className: "text-danger-500"
  },
  [CanadianCriminalReportState.Expired]: {
    label: "Expired",
    className: "text-danger-500"
  },
  [CanadianCriminalReportState.Done]: {
    label: "Done",
    className: "text-content-1000"
  },
  [CanadianCriminalReportState.NotResident]: {
    label: "Wasn’t a Canadian resident",
    className: "text-content-200"
  }
};

export const CanadianCriminalReportStatus = ({
  verification
}: {
  verification: Pick<Verification, "status" | "summary">;
}) => {
  const reportState = getCanadianCriminalReportState(verification);

  const stateLabel = reportState ? STATE_LABELS[reportState] : undefined;

  if (!stateLabel) return <EmptyCellIcon />;

  const { label, className } = stateLabel;

  return <p className={`${className} text-sm font-medium`}>{label}</p>;
};
